import { Quote } from '@britishcouncil/react-solas-ors3';

export const BangladeshWarningMsg = () => (
  <Quote intent="warning" title="Private Candidates">
    <ol>
      <li>
        <b>Payment at the Bank</b>
        <ul>
          <li>
            Settle your fees in cash at any Standard Chartered Bank{' '}
            <a href="https://www.britishcouncil.org.bd/sites/default/files/service1_updated_11_oct.pdf">Service-1</a>{' '}
            booth
          </li>
          <li>Ensure your payment is completed on or before the final registration date</li>
          <li>
            On the payment slip, clearly write the <b>last seven digits</b> of your Registration Reference Number. For
            instance, if your number is
            <br /> A2BD-G0000000000<b>1234567</b>, you only need to provide the final <b>1234567</b>.
          </li>
        </ul>
      </li>
      <li>
        <b>Documentation and Receipts</b>
        <ul>
          <li>
            The bank will issue a confirmation slip once they receive your payment. Keep this slip safe for your future
            reference
          </li>
          <li>You do not need to submit any registration documents or forms at the bank.</li>
        </ul>
      </li>
      <li>
        <b>Verification and Confirmation</b>
        <ul>
          <li>Please wait for an automated payment confirmation email from the British Council.</li>
        </ul>
      </li>
    </ol>
    <p>
      If you have not received this confirmation within seven days after the registration deadline, please contact our
      Customer Services for assistance.
    </p>
  </Quote>
);
